module.exports = __webpack_public_path__ + "static/media/signage-indoor-img64.e0cab83e.jpg";